import { useId, type ReactNode } from 'react'

export type SettingsCardProps = { heading: ReactNode; description?: string; children: ReactNode }

export function SettingsCard({ heading, description, children }: SettingsCardProps) {
  const headingId = useId()

  return (
    <section aria-labelledby={headingId} className="tw:flex tw:flex-col tw:gap-3">
      <div>
        <h2 id={headingId} className="tw:m-0 tw:text-base tw:font-semibold tw:text-gray-cool-900">
          {heading}
        </h2>
        {description && <p className="tw:m-0 tw:text-sm tw:text-gray-cool-600">{description}</p>}
      </div>
      <div className="tw:rounded-xl tw:border tw:border-gray-cool-200 tw:bg-white tw:shadow-xs">{children}</div>
    </section>
  )
}
